import { DateTime } from 'luxon';
import { DocumentApiModel } from './document.api-model';
import { ImageApiModel } from './image.api-model';
import type IPressRelease from '../../../models/press/press-release.model';
import type IDocument from '../../../models/press/document.model';

export class PressReleaseApiModel {
  public static mapToBusinessModel(apiModel: PressReleaseApiModel): IPressRelease {
    return {
      id: apiModel.id.toString(),
      title: apiModel.title,
      leadText: apiModel.leadText,
      body: apiModel.body,
      published: DateTime.fromISO(apiModel.published),
      mainImage: ImageApiModel.mapToBusinessModel(apiModel.mainImage),
      images: apiModel.images.map(ImageApiModel.mapToBusinessModel),
      documents: apiModel.documents.map(DocumentApiModel.mapToBusinessModel),
    };
  }

  public id!: number;
  public title!: string;
  public leadText!: string;
  public body!: string;
  public published!: string;
  public mainImage!: ImageApiModel;
  public images!: ImageApiModel[];
  public documents!: IDocument[];
}
